module.exports = __webpack_public_path__ + "media/application/images/img/overlays/05-5014f9cce435c71ade6395a5ed0c50e7.png";